import { getColorway } from 'utils/styles';
import { StarFilled } from '@1debit/icons';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { SharedBentoBoxCardProps } from 'types/sharedComponents';

interface Props extends SharedBentoBoxCardProps {
  stars: string;
}

const BentoBoxAppReviewCard = ({ color, cardHeadlineRte, copy, stars }: Props) => {
  return (
    <div className={`md:aspect-2/1 rounded-lg p-6 font-sans ${getColorway(color)}`}>
      <p className="font-[670] text-[32px] flex items-center gap-2">
        {stars} <StarFilled className={'inline-block h-[32px]'} />
      </p>
      <div className="text-body-saans">
        <div className="font-bold">
          <RichTextCopy copy={cardHeadlineRte} />
        </div>
        {copy && (
          <div className="font-medium">
            <RichTextCopy copy={copy} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BentoBoxAppReviewCard;
